import OtpInput from "@/components/otp/OtpInput.vue"

export default OtpInput;